import dayjs from '../plugins/dayjs';
// eslint-disable-next-line import/prefer-default-export
export const listPayouts = {
  data: () => ({
    payouts: [],
    payoutsSearchObject: {
      page: 0,
      maxPerPage: 10,
      sort: '-statusAt',
      status: 'paid',
      statusAtStart: dayjs().subtract(1, 'month').startOf('month').format(),
      statusAtEnd: dayjs().subtract(1, 'month').endOf('month').format(),
    },
    payoutsLoading: true,
    payoutsListInfo: {
      totalCount: 0,
    },
  }),
  watch: {
    payouts() {
      this.payoutsLoading = false;
    },
  },
  methods: {
    async listPayouts() {
      this.payoutsLoading = true;
      const { data, headers, errorCode } = await this.$store.dispatch('payouts/listPayouts', this.payoutsSearchObject);
      if (data) {
        this.payouts = data;
      }
      if (errorCode) {
        this.payoutsLoading = false;
      }
      this.payoutsListInfo = this.formatHeaders(headers);
    },
    formatHeaders(headers) {
      if (!headers) return {};
      return {
        totalCount: Number(headers['x-total-count'] || 0),
      };
    },
  },
};

export const listChargesForPayout = {
  data: () => ({
    charges: [],
    chargesSearchObject: {
      page: 0,
      maxPerPage: 10,
      sort: '-createdAt',
    },
    chargesLoading: true,
    chargesListInfo: {
      totalCount: 0,
    },
  }),
  watch: {
    charges() {
      this.chargesLoading = false;
    },
  },
  methods: {
    async clearCharges() {
      this.charges = [];
      this.chargesListInfo = {
        totalCount: 0,
      };
    },
    async listChargesForPayout() {
      await this.clearCharges();
      this.chargesLoading = true;
      const { data, headers, errorCode } = await this.$store.dispatch('payouts/listChargesForPayout', this.chargesSearchObject);
      if (data) {
        this.charges = data;
      }
      if (errorCode) {
        this.chargesLoading = false;
      }
      this.chargesListInfo = this.formatHeaders(headers);
    },
    formatHeaders(headers) {
      if (!headers) return {};
      return {
        totalCount: Number(headers['x-total-count'] || 0),
      };
    },
  },
};
